import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FeatureToggle } from '@Enums';
import { UserAdminService, FeatureManagerService } from '@Services';
import { UserFormState } from 'app/enums/global/userprofile-userform-state.enum';
import { SharedModule } from '@Shared/shared.module';
import { UnavailabilityScheduleComponent } from '../components/unavailability-schedule/unavailability-schedule.component';
import { UserActivityComponent } from '../components/user-activity/user-activity.component';
import { EditUsersClientAccountsComponent } from '../components/edit-users-client-accounts/edit-users-client-accounts.component';
import { EditUsersProfileComponent } from '../components/edit-user-profile/edit-user-profile.component';

@Component({
  selector: 'app-edit-users-v2',
  templateUrl: './edit-users-v2.component.html',
  styleUrls: ['./edit-users-v2.component.scss'],
  imports: [SharedModule, UnavailabilityScheduleComponent, UserActivityComponent, EditUsersClientAccountsComponent, EditUsersProfileComponent]
})

export class EditUsersV2Component {
  @Input() selectedUser: any;
  @Input() accounts: any[];
  @Input() isReadOnly: boolean;
  clients: any[];
  filteredAccounts: any[];
  clientAccountsDictionary: Record<string, any[]>;
  userName: any;
  filterText = '';
  expandAll = false;
  shouldReload = false;
  isUserFormValid = true;
  userFormState: UserFormState = UserFormState.None;

  isDistributionEnabled = false;
  unavailabilityScheduleEnabled = false;

  constructor(
    public editUserDialogRef: MatDialogRef<EditUsersV2Component>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly userAdminService: UserAdminService,
    private readonly featureManagerService: FeatureManagerService
  ) {
    this.selectedUser = data.user;
    this.accounts = data.accounts;
    this.isReadOnly = data.isReadOnly;
  }

  ngOnInit() {
    this.subscribeFeatureFlags();
    this.clients = this.selectedUser?.clients;
    this.filteredAccounts = this.accounts.sort((a, b) => {
      const nameA = a.clientName ?? "";
      const nameB = b.clientName ?? "";
      return nameA.localeCompare(nameB);
    });
    
    this.generateClientAccountsDictionary();
    this.userName = this.selectedUser.firstName + ' ' + this.selectedUser.lastName;
  }

  subscribeFeatureFlags() {      
      this.isDistributionEnabled = this.featureManagerService.getByName(FeatureToggle.GlobalUsersEnableEditDistributionUser)?.enabled;
      this.unavailabilityScheduleEnabled = this.featureManagerService.getByName(FeatureToggle.GlobalEnableUnavailabilitySchedule)?.enabled;
  }

  ngOnDestroy() {
  }

  generateClientAccountsDictionary() {
    const clientAccountsDictionary: Record<string, any[]> = this.filteredAccounts.reduce((dict, account) => {
      if (!dict[account.clientName]) {
        dict[account.clientName] = [];
      }
      dict[account.clientName].push(account);
      return dict;
    }, {} as Record<string, any[]>);

    for (const clientName in clientAccountsDictionary) {
      clientAccountsDictionary[clientName].sort((a, b) => {
        return a.name.localeCompare(b.name);
      });
    }

    this.clientAccountsDictionary = clientAccountsDictionary;
  }

  filterClients(entry: any) {
    return this.clients.filter(c => c.clientName === entry.key);
  }

  filterClientsAndAccountsByText() {
    this.filteredAccounts = this.accounts.filter(a => a.clientName?.toLowerCase().includes(this.filterText.toLowerCase()) ||
                                              a.code?.includes(this.filterText) ||
                                              a.name?.toLowerCase().includes(this.filterText.toLowerCase()));
    this.generateClientAccountsDictionary();

    if(this.filterText === ''){
      this.expandAll = false;
    }
    else {
      this.expandAll = true;
    }
  }

  reloadUpdatedUser() {
    this.userAdminService.getUser(this.selectedUser.id, true).subscribe((response) => {
      this.clients = response.clients;
    });
  }

  toggleExpandAll() {
    this.expandAll = !this.expandAll;
  }

  onFormValidityChanged(isValid: boolean) {
    this.isUserFormValid = isValid;  
  }

  onFormSaveStateChanged(state: UserFormState) {
    this.userFormState = state;
    if (state === UserFormState.Saved)
    {
      setTimeout(() => {
        this.userFormState = UserFormState.None;
      }, 1500);
    }
    else if (state === UserFormState.Error)
    {
      setTimeout(() => {
        this.userFormState = UserFormState.None;
      }, 4500);
    }
  }

  close() {
    this.editUserDialogRef.close(true);
  }
}
